import React from 'react';
import { Link } from '@material-ui/core';
import './customCardheader.scss';

export const CustomCardHeader = ({
  title,
  actionBtnLabel = '',
  handleActionBtnClick,
  titleClassName,
}) => {
  const showActionBtn = !!actionBtnLabel;

  return (
    <div className='custom-card-header'>
      <h6 className='title mb-0' style={titleClassName || {}}>
        {title}
      </h6>
      {showActionBtn && (
        <Link
          component='a'
          className='btn-link action-btn'
          color='link'
          onClick={handleActionBtnClick}
        >
          <span className='actionLabelText' style={{textDecoration: 'underline'}}>{actionBtnLabel}</span>
        </Link>
      )}
    </div>
  );
};
